import { LoginType } from '../../api-types/models/LoginDto';
import { isOneOfTheFitnessGroups } from './isOneOfTheFitnessGroups';
import { getUserGroups } from './getUserGroups';
import { isBrunchLoginType, isBrunchSession } from './isBrunchSession';
import type { SerializableAuthUser } from '../../interfaces/authUser';

const brunchRoutes = ['/', '/registry', '/statistics'];
const bookingRoutes = ['/booking'];
const sportradarRoutes = ['/', '/booking', '/profile'];

export function getRoutesBasedOnUserGroups(
    user: SerializableAuthUser | null | undefined
): string[] {
    const userGroups = getUserGroups(user);
    let routes: string[] = [];

    if (userGroups.includes(LoginType.BRUNCH)) {
        routes = routes.concat(brunchRoutes);
    }

    if (isOneOfTheFitnessGroups(user)) {
        routes = routes.concat(bookingRoutes);
    }

    const loginType = localStorage.getItem('login');
    const groupsLoaded = userGroups.length > 0;

    if (!groupsLoaded) {
        if (loginType === LoginType.BRUNCH) {
            routes = routes.concat(brunchRoutes, bookingRoutes);
        } else if (loginType === LoginType.COACH) {
            routes = routes.concat(bookingRoutes);
        }
    }

    if (
        loginType === LoginType.SPORTRADAR ||
        userGroups.includes(LoginType.TENANTS) ||
        (!user && !isBrunchLoginType(loginType))
    ) {
        routes = routes.concat(sportradarRoutes);
    }

    if (isBrunchSession(loginType, userGroups)) {
        routes = routes.filter((route) => route !== '/profile');
    }

    return routes.filter(
        (value, index, array) => array.indexOf(value) === index
    );
}
